import { Injectable } from '@angular/core';
import { Action, State, StateContext } from '@ngxs/store';
import { UploadStatus, UploadType } from '@sc/data-access-models';
import {
  UploadPartnerStatusInitAction,
  UploadPartnerStatusUpdateAction,
} from './files.actions';

@State<Record<UploadType, UploadStatus>>({
  name: 'files',
  defaults: null,
})
@Injectable()
export class FilesState {
  @Action(UploadPartnerStatusUpdateAction)
  updateStatus(
    ctx: StateContext<Record<UploadType, UploadStatus>>,
    { payload }: UploadPartnerStatusUpdateAction
  ): void {
    const state = ctx.getState();
    ctx.setState(
      state
        ? {
            ...state,
            uploadPartners: payload,
          }
        : {
            uploadPartners: payload,
          }
    );
  }

  @Action(UploadPartnerStatusInitAction)
  updateState(
    ctx: StateContext<Record<UploadType, Partial<UploadStatus>>>
  ): void {
    const state = ctx.getState();
    ctx.setState(
      state
        ? {
            ...state,
            uploadPartners: {
              status: 'start',
              dateBegin: new Date(),
            },
          }
        : {
            uploadPartners: {
              status: 'start',
              dateBegin: new Date(),
            },
          }
    );
  }
}
